import { Calendar, CheckSquare, Clock, Inbox } from 'lucide-react';

export function DashboardPage() {
  return (
    <div className="max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold text-text-primary mb-6">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatCard icon={CheckSquare} label="Open Tasks" value="—" />
        <StatCard icon={Clock} label="Due This Week" value="—" />
        <StatCard icon={Calendar} label="Meetings Today" value="—" />
        <StatCard icon={Inbox} label="Inbox Items" value="—" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Section title="Today's Meetings">
          <EmptyState message="No meetings scheduled for today." />
        </Section>

        <Section title="Overdue Tasks">
          <EmptyState message="No overdue tasks. You're all caught up." />
        </Section>

        <Section title="Tasks Due This Week">
          <EmptyState message="No tasks due this week." />
        </Section>

        <Section title="Recent Quick Captures">
          <EmptyState message="Nothing in your inbox." />
        </Section>
      </div>
    </div>
  );
}

function StatCard({
  icon: Icon,
  label,
  value,
}: {
  icon: React.ComponentType<{ size?: number }>;
  label: string;
  value: string;
}) {
  return (
    <div className="bg-bg-card border border-border rounded-lg p-4">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-md bg-accent/10 text-accent">
          <Icon size={18} />
        </div>
        <div>
          <p className="text-2xl font-bold text-text-primary">{value}</p>
          <p className="text-xs text-text-muted">{label}</p>
        </div>
      </div>
    </div>
  );
}

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="bg-bg-card border border-border rounded-lg">
      <div className="px-4 py-3 border-b border-border">
        <h2 className="text-sm font-semibold text-text-secondary">{title}</h2>
      </div>
      <div className="p-4">{children}</div>
    </div>
  );
}

function EmptyState({ message }: { message: string }) {
  return (
    <p className="text-sm text-text-muted text-center py-4">{message}</p>
  );
}
